import { render, staticRenderFns } from "./DatasetIssueList.vue?vue&type=template&id=615a4a1f"
import script from "./DatasetIssueList.vue?vue&type=script&lang=js"
export * from "./DatasetIssueList.vue?vue&type=script&lang=js"
import style0 from "./DatasetIssueList.vue?vue&type=style&index=0&id=615a4a1f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports